// extracted by mini-css-extract-plugin
export var burgerIcon = "burgerMenu-module--burgerIcon--ox9ow";
export var menuClose = "burgerMenu-module--menuClose--3_oNV";
export var menuOpen = "burgerMenu-module--menuOpen--I5cgi";